<template>
  <v-dialog
    v-model="display"
    persistent
    max-width="800px"
    scrollable
    v-if="display"
  >
    <v-form ref="procedureForm">
      <v-card min-height="200px">
        <v-card-title>
          <v-row>
            <v-col class="headline">Gestion de la demande</v-col>
          </v-row>
        </v-card-title>
        <v-card-text class="text--primary">
          <ResumeDossier :dossier="dossier" title="Ce dossier concerne :" />
          <v-container>
            <v-row>
              <v-col><v-divider></v-divider></v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-checkbox v-model="avis.enAttente" label="En attente">
                </v-checkbox>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="pt-0">
                <v-textarea
                  v-model="avis.notes"
                  label="Notes :"
                  class="pa-1 mt-0"
                  hide-details
                  counter
                  :rules="notesRules"
                >
                </v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col><v-divider></v-divider></v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-radio-group v-model="avis.avis">
                  <v-radio :value="true" label="avis favorable"></v-radio>
                  <v-radio :value="false" label="avis défavorable"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="pt-0">
                <v-textarea
                  v-model="avis.visite.commentaire"
                  label="commentaire :"
                  class="pa-1 mt-0"
                  hide-details
                  counter
                  :rules="commentaireRules"
                >
                </v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <p v-if="!formValid" class="text-caption red--text">
            Un ou plusieurs champs sont mal renseignés
          </p>
          <v-spacer></v-spacer>
          <v-btn small class="white--text" @click="sendAction" color="primary">
            Enregistrer
          </v-btn>
          <v-btn
            small
            class="white--text"
            @click="displayed = false"
            color="primary"
          >
            Annuler
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import ResumeDossier from "@/components/ResumeDossier";

export default {
  name: "ModalEditAvisRPO",
  components: { ResumeDossier },
  props: ["avis", "dossier", "display"],
  data() {
    return {
      formValid: true,
      notesRules: [v => (v || "").length <= 500 || "500 caractères maximum"],
      commentaireRules: [
        v => (v || "").length <= 2000 || "2000 caractères maximum"
      ]
    };
  },
  computed: {
    displayed: {
      get() {
        return this.display;
      },
      set(value) {
        this.$emit("update:display", value);
      }
    }
  },
  methods: {
    sendAction() {
      if (this.$refs.procedureForm.validate()) {
        this.formValid = true;
        this.$emit("ModalAvisRPOAction", this.avis);
        this.displayed = false;
        this.$toast.success("L'avis a été enregistré");
      } else {
        this.formValid = false;
      }
    }
  }
};
</script>
